export const ShareScreenIcon = (
  <svg className="size-4" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5002 25.6666H17.5002C23.3335 25.6666 25.6668 23.3333 25.6668 17.5V10.5C25.6668 4.66665 23.3335 2.33331 17.5002 2.33331H10.5002C4.66683 2.33331 2.3335 4.66665 2.3335 10.5V17.5C2.3335 23.3333 4.66683 25.6666 10.5002 25.6666Z"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 11.095L14 7.59503L17.5 11.095"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 7.59503V16.9284"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 19.2617C11.5383 20.7783 16.4617 20.7783 21 19.2617"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
